<template>
    <div>
        <div class="logo"><img id="logo" alt="CENPROT Nacional" src="~@/assets/imgs/logo.svg" /></div>
        <loader loading-text="Por favor, aguarde..." :background='true' :loading='loading'  />
        <div class="termo-aceite-bg">
            <img src="@/assets/imgs/corporate-businessmen-working-tablet-office.png"/>
        </div>
        <!-- <b-modal id="modal-recusa" size="lg" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <template v-slot:modal-header="{ close }">
                <h5>Importante: Atualização dos Termos de Uso</h5>
            </template>
            <template v-slot:default="{ hide }">
                <p><span>Informamos que houve uma atualização nos Termos de Uso da CENPROT Nacional. Para continuar utilizando nossos serviços, solicitamos que revise e aceite os novos termos.</span></p>
            </template>
            <template v-slot:modal-footer="{ ok }">
                <b-button size="lg" variant="danger" @click="respConfirm('s')" class="ml-auto">Prosseguir</b-button>
            </template>
        </b-modal> -->
        <b-modal
            ref="termoModal"
            size="xl"
            scrollable
            title="Resultado"
            id="termo-modal"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header-close="true" 
            >
            <template v-slot:modal-header="{ close }">
                <h5>Importante: Atualização dos Termos de Uso</h5>
            </template>
            <template v-slot:default="{ hide }">
                <p v-if="steps[step].mensagem"><span v-html="steps[step].mensagem"></span></p>
                <object v-if="step==1" width="100%" style="height:calc(100vh - (81px + 65px + 56px + 32px) - 5px);" type="application/pdf" :data="pdf"></object>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button v-if="steps[step].btnCancelar" 
                    ref="btnCancelar"
                    size="lg"
                    variant="danger"
                    class="mr-auto" 
                    @click="respConfirm(false)"
                >
                    {{steps[step].btnCancelar}}
                </b-button>
                <b-button v-if="steps[step].btnOk" 
                    ref="btnOk"
                    size="lg"
                    variant="success"
                    @click="respConfirm(true)"
                >
                    {{steps[step].btnOk}}
                </b-button>
            </template>
        </b-modal>
        <!-- <b-modal id="modal-recusa" size="lg" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <template v-slot:modal-header="{ close }">
                <h5>Atenção</h5>
            </template>
            <template v-slot:default="{ hide }">
                <p><span v-html="mensagem"></span></p>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button size="lg" variant="success" @click="respConfirm(false)" class="mr-auto">Voltar</b-button>
                <b-button size="lg" variant="danger" @click="respConfirm(true)" class="ml-auto">Sim</b-button>
            </template>
        </b-modal> -->
    </div>
</template>

<script>
import API from '@/services/api'

export default {
    components: {
    },
    data() {
        return {
            loading: false,
            showModal: true,
            pdf: "",
            step: 0,
            steps: {
                0:{
                    mensagem:"Informamos que houve uma atualização nos Termos de Uso da CENPROT Nacional. Para continuar utilizando nossos serviços, solicitamos que revise e aceite os novos termos.",
                    btnOk:'Prosseguir',
                    btnCancelar:false,
                },
                1:{
                    mensagem: false,
                    btnOk:'Aceitar',
                    btnCancelar:'Recusar',
                },
                2:{
                    mensagem:"Obrigado! Aguarde um instante enquanto lhe redirecionamos.",
                    btnOk:false,
                    btnCancelar:false,
                },
                3:{
                    mensagem:"Ao recusar os termos, ficará incapacitado de prosseguir com a utilização dos serviços da CENPROT Nacional. Deseja continuar?",
                    btnOk:'Voltar',
                    btnCancelar:'Sim',
                },
                4:{
                    mensagem:"Aguarde! Você sera desconectado e redirecionado para a página inicial em alguns segundos.",
                    btnOk:false,
                    btnCancelar:false,
                },
            }
        };
    },
    methods: {
        respConfirm(resposta) {
            if (this.$refs.btnCancelar) this.$refs.btnCancelar.blur();
            if (this.$refs.btnOk) this.$refs.btnOk.blur();
            switch (this.step) {
                case 0:
                    if(resposta) this.step = 1; 
                    break;
                case 1:
                    if(resposta) this.aceitaTermoAceite();
                    else this.step = 3; 
                    break;
                case 3:
                    if(!resposta) {
                        this.step = 4;
                        setTimeout(() => {
                            this.$root.logout();
                        }, 1000);
                    }
                    else this.step = 1;
                    break;
            }
        },
        async aceitaTermoAceite(){
            this.loading = true;
            const token = localStorage.getItem("jwtToken");
            API.post("/usuario/termo-aceite-site/aceite", { token }).then((res) => {
                this.loading = false;
                if(res.data.situacao){
                    this.step = 2;
                    setTimeout(() => {
                        this.$router.push({ name: "painel" })
                    }, 3000);
                }
                else {
                    alert("Erro ao confirmar aceitação dos termos.")
                    this.$router.push({ name: "termoAceiteSite" })
                }
            }).catch((err) => {
                this.loading = false;
                alert("Erro ao confirmar aceitação dos termos.")
                this.$router.push({ name: "termoAceiteSite" })
            });
        },
        getTermoAceite(){
            return new Promise((resolve, reject) => {
                API.get("/usuario/termo-aceite-site/resgata").then((res) => {
                    let response = "data:application/pdf;base64, " + encodeURI(res.data.pdf);
                    resolve(response);                       
                }).catch((error) => {
                    throw new Error(false);
                });
            });
        },
    },
    computed: {
    },
    mounted(){
        this.loading = true;
        const handleTermo = async () => {
            try {
                let termoAceite = await this.getTermoAceite();
                this.pdf = termoAceite;
                this.$bvModal.show("termo-modal");
            } 
            catch (error) {
                console.log(error);
            } 
            finally{
                this.loading = false;
            }
        };
        handleTermo();
    },
};
</script>

<style scoped>
.logo{
    height: fit-content;
    position: absolute;
    background: white;
    border-radius: 7px;
    top: 50px;
    min-width: 190px;
    padding: 14px;
    width: 230px;
    left: 50%;
    margin-left: -115px;
    z-index:10;
}
.termo-aceite-bg{display:flex;width:100%;height:100%;background: linear-gradient(180deg, #1ACEB5 0%, #4780F1 100%) 0% 0% no-repeat padding-box;}
.termo-aceite-bg img{width: 100%; height: 100%;mix-blend-mode: multiply;object-fit: cover;}

h5 {
    font: normal normal bold 20px/20px 'Kanit', sans-serif;
    color: #597EB5;
}
.btn{
    height: 44px;
    font: normal normal bold 15px/15px 'Kanit', sans-serif;
    border-radius: 5px;
    opacity: 1;
    border: none;
    outline: none;
}
.btn.btn-success{
    width: 160px;
    background: #1ACEB5 0% 0% no-repeat padding-box;
}
.btn.btn-danger{
    width: 196px;
    color: #702727;
    border: 3px solid transparent;
    background: none;
    /* margin-right: auto; */
}
.btn.btn-danger:hover{
    border: 3px solid #702727;
}
.btn.btn-success:disabled{
    background:#1aceb55c 0% 0% no-repeat padding-box
}
.btn.btn-danger:disabled{
    border: 3px solid #F8CBCB;
    background: #F8CBCB 0% 0% no-repeat padding-box;
}
.btn:active,
.btn:focus{
    box-shadow: none;
    border: none;
    outline: none;
}
.btn.btn-success:active,
.btn.btn-success:focus{
    background: #1ACEB5 0% 0% no-repeat padding-box;
}
.btn.btn-danger:active,
.btn.btn-danger:focus{
    background: #702727 0% 0% no-repeat padding-box;
    border: 3px solid #702727;
    color: white;
}
</style>
